"use strict";

export function initInScope($scope) {
   let close=  $scope.find('.js-newsletter-banner-close');
   let newsletterBanner=  $scope.find('.js-newsletter-banner');
   close.on('click', function (){
       document.cookie = "banner-closed=true; expires='';";
        newsletterBanner.addClass('d-none');
   })
}